import React, { ReactNode, useEffect, useRef } from 'react'
import { createRoot } from 'react-dom/client'
import { Mention } from 'shared/components/editor/mention'
import { parseTextWithMentions } from 'modules/community/components/editor/utils/parse-text-with-mentions'
import { MentionInterface } from '../comment/comment.types'

interface TextWithMentionsProps extends React.HTMLProps<HTMLDivElement> {
  text: string
  mentions: MentionInterface[]
}

export const TextWithMentions = ({ text, mentions, ...rest }: TextWithMentionsProps): ReactNode => {
  const containerRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (containerRef.current) {
      containerRef.current.innerHTML = parseTextWithMentions(
        text.replace(/(?:<br\s*\/?>)+$/i, ''),
        mentions,
      )

      const mentionElements =
        containerRef.current.querySelectorAll<HTMLSpanElement>('[data-type="mention"]')
      mentionElements?.forEach(element => {
        const id = element.dataset.id
        const displayName = element.dataset.cy?.split('mention-').pop()
        const profileImageUrl = element.dataset.avatarUrl

        const root = createRoot(element)
        root.render(
          <Mention
            element={{
              displayName: displayName || '',
              id: Number(id) || 0,
              profileImageUrl: profileImageUrl || '',
            }}
          />,
        )
      })
    }
  }, [text, mentions])

  return <div ref={containerRef} {...rest} dir="auto" />
}
